import React from "react";
import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import useThemeStore from "@/shared/stores/useThemeStore";

interface GlobalNoDataProps {
  title?: string;
  subtitle?: string;
  titleKey?: string;
  subtitleKey?: string;
  ns?: string;
}

export default function GlobalNoData({
  title,
  subtitle,
  titleKey,
  subtitleKey,
  ns = "taascard",
}: GlobalNoDataProps) {
  const { darkMode } = useThemeStore();
  const { t } = useTranslation();

  const resolvedTitle = title ?? (titleKey ? t(titleKey, { ns }) : "");
  const resolvedSubtitle =
    subtitle ?? (subtitleKey ? t(subtitleKey, { ns }) : "");

  return (
    <Box
      sx={{
        py: { xs: 4, sm: 6 },
        textAlign: "center",
        px: { xs: 2, sm: 0 },
      }}
    >
      <Box
        sx={{
          borderRadius: 3,
          border: "1px dashed",
          borderColor: darkMode ? "var(--neutral-700)" : "var(--neutral-300)",
          backgroundColor: darkMode ? "var(--neutral-900)" : "white",
          px: { xs: 2, sm: 4 },
          py: { xs: 4, sm: 6 },
          textAlign: "center",
          maxWidth: 520,
          mx: "auto",
        }}
      >
        {!!resolvedTitle && (
          <Typography
            variant="h6"
            sx={{
              fontFamily: '"Lexend", sans-serif',
              fontWeight: 600,
              color: darkMode ? "var(--neutral-100)" : "var(--neutral-900)",
              mb: 1,
            }}
          >
            {resolvedTitle}
          </Typography>
        )}

        {!!resolvedSubtitle && (
          <Typography
            variant="body2"
            sx={{
              color: darkMode ? "var(--neutral-400)" : "var(--neutral-600)",
              lineHeight: { xs: 1.5, sm: 1.6 },
            }}
          >
            {resolvedSubtitle}
          </Typography>
        )}
      </Box>
    </Box>
  );
}
